import data from './i18n-defaults.json';

// this file exists only for comfortable use of the frontend devs when dealing with translation keys.
// what "turnObjectToAnObjectWhereKeysAndValuesAreIdentical" basically does is take this object of translations, for example:
// { CONFIRM_BUTTON_TEXT: 'Confirm" }
// and change it to:
// { CONFIRM_BUTTON_TEXT: 'CONFIRM_BUTTON_TEXT' }
// so we can use it like this: <I18n id={i18nKeys.CONFIRM_BUTTON_TEXT} />
// wrapping here everything with typescript for a complete autocomplete experience

const turnObjectToAnObjectWhereKeysAndValuesAreIdentical = (obj: { [key: string]: string }) => {
  const keysObject: { [key: string]: string } = {};
  Object.keys(obj).forEach(key => {
    keysObject[key] = key;
  });

  return keysObject;
};
const i18nKeys = turnObjectToAnObjectWhereKeysAndValuesAreIdentical(data) as {
  [key in keyof typeof data]: keyof typeof data;
};

export { i18nKeys };
